<p-toast position="top-right"></p-toast>

<partner-marketing-add-edit-promotion *ngIf="showAddEditPromotionSideBar"
                                      [_promoId]="selectPromoId"
                                      [_promoTypeId]="selectPromoTypeId"
                                      [_showAddEditPromotionSideBar]="showAddEditPromotionSideBar"
                                      [partnerMarketingPromotionsComponent]="this"
                                      (changedShowAddEditPromotionSideBarEmit)="changedShowAddEditPromotionSideBarEmit($event)"></partner-marketing-add-edit-promotion>

<partner-marketing-filter-promotion *ngIf="visiblePartnerMarketingFilterPromotion"
                                    [visiblePartnerMarketingFilterPromotion]="visiblePartnerMarketingFilterPromotion"
                                    [partnerMarketingPromotionsComponent]="this"
                                    [_filterObj]="filterObj"
                                    (changedShowPartnerMarketingFilterPromotionSideBarEmit)="changedShowPartnerMarketingFilterPromotionSideBarEmit($event)"></partner-marketing-filter-promotion>

<!-- Table -->
<p-table #promosGrid
         [columns]="promoCols"
         [value]="promos"
         [lazy]="true"
         responsiveLayout="scroll" dataKey="Id"
         (onLazyLoad)="handlePromoLazyLoad($event)"
         [paginator]="true"
         [(first)]="first"
         [rows]="rowsPerPage"
         [rowsPerPageOptions]="rowsPerPageOptions"
         [totalRecords]="totalRecords"
         [resizableColumns]="true"
         [columnResizeMode]="'expand'"
         [autoLayout]="true"
         [styleClass]="'p-datatable-gridlines'"
         [scrollable]="true"
         [scrollHeight]="'flex'">
    <ng-template pTemplate="caption">
        <div class="flex flex-row sp-header">
            <div class="sp-header__col-left">
                <div class="sp-header__title">All Promotions</div>
            </div>
            <div class="flex flex row sp-header__col-right">
                <div>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" class="search-input"
                               [(ngModel)]="filter.searchName" (input)="handleFilterChange()"
                               placeholder="Search here..." />
                    </span>
                </div>
                <div class="ml-20">
                    <button class="white-btn-filter" pButton label="Filter" (click)="openPartnerMarketingFilterPromotionSideBar()"></button>
                </div>
                <div class="ml-20">
                    <button class="bluedark-btn-filter" pButton label="Create Promotion" (click)="openMerchantCreatePromotionSideBar()"></button>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th *ngFor="let col of promoCols"
                [pSortableColumn]="col.field"
                [pSortableColumnDisabled]="col.disableSort"
                pResizableColumn
                [style.width]="col.width">
                {{col.header}}
                <p-sortIcon *ngIf="sortField===col.field" [field]="col.field"></p-sortIcon>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-promo>
        <tr [pSelectableRow]="promo">
            <td class="ui-resizable-column">
                <span style="cursor: pointer;" (click)="openMerchanteditPromotionSideBar(promo.Id, promo.PromoTypeId)">{{promo.Id}}</span>
            </td>
            <td class="ui-resizable-column">{{promo.PromoTypeText}}</td>
            <td class="ui-resizable-column">{{promo.Code}}</td>
            <td class="ui-resizable-column">{{promo.Name}}</td>
            <td class="ui-resizable-column">{{promo.UseAmount}}</td>
            <td class="ui-resizable-column">{{promo.MinSpend}}</td>
            <td class="ui-resizable-column">{{promo.StartedAt}}</td>
            <td class="ui-resizable-column">{{promo.ValidUntil}}</td>
            <td class="ui-resizable-column">{{promo.PromoAvailableText}}</td>
            <td class="ui-resizable-column">{{promo.MaxUseCount}}</td>
            <td class="ui-resizable-column">
                <div class="flex flex-row">
                    <div>
                        <p-inputSwitch [(ngModel)]="promo.IsActive" (onChange)="switchPromo(promo)"></p-inputSwitch>
                    </div>
                    <div class="table-col-item-isactive">
                        <span *ngIf="promo.IsActive" class="table-col-item-isactive__active">Active</span>
                        <span *ngIf="!promo.IsActive" class="table-col-item-isactive__notactive">Inactive</span>
                    </div>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="paginatorleft" let-state>
        <div *ngIf="promos !== null && promos.length > 0" style="padding-left: 10px">
            Displaying {{first + 1}} - {{first + promos.length}} of {{totalRecords}}
        </div>
    </ng-template>
</p-table>